
export const BREAKPOINT_MIN_REM = {
  tablet: 40,
  tabletWide: 48,
  desktop: 56,
} as const;

export type Breakpoint = 'phone' | 'tablet' | 'tabletWide' | 'desktop';

export const BREAKPOINT_QUERIES = {
  tabletUp: `(min-width: ${BREAKPOINT_MIN_REM.tablet}rem)`,
  tabletWideUp: `(min-width: ${BREAKPOINT_MIN_REM.tabletWide}rem)`,
  desktopUp: `(min-width: ${BREAKPOINT_MIN_REM.desktop}rem)`,
} as const;

const ONE_PX_REM = 0.0625;

export const BREAKPOINT_CUSTOM_MEDIA = {
  '--bp-phone': `(max-width: ${BREAKPOINT_MIN_REM.tablet - ONE_PX_REM}rem)`,
  '--bp-tablet-down': `(max-width: ${BREAKPOINT_MIN_REM.tabletWide - ONE_PX_REM}rem)`,
  '--bp-tablet-wide-down': `(max-width: ${BREAKPOINT_MIN_REM.desktop - ONE_PX_REM}rem)`,
  '--bp-tablet-up': BREAKPOINT_QUERIES.tabletUp,
  '--bp-tablet-wide-up': BREAKPOINT_QUERIES.tabletWideUp,
  '--bp-desktop-up': BREAKPOINT_QUERIES.desktopUp,
} as const;

export function breakpointCustomMediaCss(): string {
  return Object.entries(BREAKPOINT_CUSTOM_MEDIA)
    .map(([name, query]) => `@custom-media ${name} ${query};`)
    .join('\n');
}
